import { animate, style, transition, trigger } from '@angular/animations'
import { Component, computed, input, output } from '@angular/core'
import { RouterModule } from '@angular/router'
import { IonButton, IonLabel } from '@ionic/angular/standalone'
import { AccountTM, ActivationChannel, HardwareId, UserLocale } from '@naturalcycles/shared'
import { BoxComponent } from '@src/app/cmp/box/box.component.js'
import { ROUTES } from '@src/app/cnst/nav.cnst.js'
import { MarkdownDirective } from '@src/app/dir/markdown/markdown.directive.js'
import { TrPipe } from '@src/app/pipes/tr.pipe.js'

@Component({
  selector: 'app-fertility-blocker',
  templateUrl: 'fertility-blocker.component.html',
  styleUrls: ['fertility-blocker.component.scss'],
  imports: [BoxComponent, IonButton, IonLabel, TrPipe, MarkdownDirective, RouterModule],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        animate('0ms', style({ transform: 'translateY(100%)', opacity: 0 })),
        animate('300ms ease-in-out', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('300ms ease-in-out', style({ transform: 'translateY(100%)', opacity: 0 })),
      ]),
    ]),
  ],
})
export class FertilityBlockerComponent {
  public account = input.required<AccountTM>()
  public userLocale = input.required<UserLocale>()
  public state = input.required<FertilityBlockerState>()

  protected clickCta = output<FertilityBlockerCTA>()

  protected hwId = computed(() => this.account().hwId)
  protected countryCode = computed(() => this.account().shippingAddress?.countryCode)
  protected tempScale = computed(() => (this.account().fahrenheit ? 'fahrenheit' : 'celsius'))
  protected activationChannel = computed(() => this.account().activationChannel)
  protected canDeliver = computed(() => this.userLocale().canDeliver)
  protected isNoThermState = computed(() => NO_THERM_STATES.includes(this.state()))

  protected HardwareId = HardwareId
  protected ActivationChannel = ActivationChannel
  protected ROUTES = ROUTES
  protected FertilityBlockerState = FertilityBlockerState
  protected FertilityBlockerCTA = FertilityBlockerCTA
}

export enum FertilityBlockerState {
  NO_THERM = 'NO_THERM',
  WAITING = 'WAITING',
  HAS_THERM = 'HAS_THERM',
  CONNECTED_THERM_UNPAIRED = 'CONNECTED_THERM_UNPAIRED',
  UEBE_NO_THERM = 'UEBE_NO_THERM',
  T3_NO_THERM = 'T3_NO_THERM',
}

const NO_THERM_STATES = [
  FertilityBlockerState.NO_THERM,
  FertilityBlockerState.UEBE_NO_THERM,
  FertilityBlockerState.T3_NO_THERM,
]

export enum FertilityBlockerCTA {
  ADD_DATA = 1,
  BUY_THERMOMETER = 2,
  THERMOMETER_CONNECTION = 3,
  AW_CONNECTION = 4,
  CALIBRATE = 5,
}
